import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Aboutpage from './components/pages/Aboutpage';
import Project from './components/pages/Project';
import Mitsubishi from './components/pages/Mitsubishi';

import Carrier from './components/pages/Carrier';
import Hitachipage from './components/pages/Hitachipage';
import Cassette4way from './components/pages/Cassette4way';
import Toshibapage from './components/pages/Toshibapage';
import Services from './components/pages/Services';
import Daikin from './components/pages/Daikin';

function App() {
   return (
     <Router>
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
       <Route axact path="/contactus" element={<Contactus/>}/>
        <Route axact path="/aboutus" element={<Aboutpage/>}/>
         <Route axact path="/Project" element={<Project/>}/>
           <Route axact path="/Mitsubishi" element={<Mitsubishi/>}/>
              <Route axact path="/toshibaac" element={<Toshibapage/>}/>
                   <Route axact path="/Hitachi" element={<Hitachipage/>}/>
                         <Route axact path="/Carrier" element={<Carrier/>}/>
                           <Route axact path="/daikin" element={<Daikin/>}/>
                           <Route axact path="/services" element={<Services/>}/>
                        <Route axact path="/4way-cassett" element={<Cassette4way/>}/>
          </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
